var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modify-apply-block',{ref:"rew_p",attrs:{"data-type":"rew","dataFileParm":{docName: '奖励信息', isDoc: true},"getTitle":_vm.getTitle,"getEdit":_vm.getEdit,"saveEdit":_vm.saveEdit,"addEdit":_vm.addEdit,"initAddFormData":_vm.initAddFormData,"form-parms-add":_vm.formParmsAdd,"block-name":"奖励信息","ref-name":"rew","worker-id":_vm.workerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }